import { ToasterProps } from './interface'
import withToaster from './ToasterManager'
import ToasterProvider from './ToasterProvider'

export { ToasterProvider, ToasterProps, withToaster }
export default ToasterProvider
